import { createSlice } from '@reduxjs/toolkit';
import { apiUrl } from '../../utils/endPoints/apiUrl';
import { apiRequest } from '../../utils/config/apiRequest';

// Initial filter
const initialFilter = { page: 1, limit: 5, searchQ: '' };

// Initial state
const initialState = {
    isLoading: false,
    staffListing: { rows: [], count: 0, searchQ: '' },
    staffDetail: {},
    filter: initialFilter,
};

// Create the slice
const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },

        stopLoading(state) {
            state.isLoading = false;
        },

        setStaffListing(state, action) {
            state.staffListing = action.payload;
        },

        setStaffDetail(state, action) {
            state.staffDetail = action.payload;
        },

        setFilter(state, action) {
            state.filter = { ...initialFilter, ...action.payload };
        },
    },
});

// Export actions
export const { startLoading, stopLoading, setStaffListing, setStaffDetail, setFilter } = staffSlice.actions;

// Async Thunk to fetch the shop list
export const fetchStaffList = ({ paginate,searchQ }) => async (dispatch) => {
    try {
        dispatch(startLoading());

        const { data, status } = await apiRequest({
            endUrl: apiUrl.staff.userStaff,
            query: paginate !== '' ? { paginate, searchQ } : initialState.filter,
        });

        if (status) {
            dispatch(setStaffListing({
                rows: data?.rows,
                count: data?.total,
            }));
        }
    } catch (error) {
        console.error('Error fetching Staff list:', error);
    } finally {
        dispatch(stopLoading());
    }
};

export const fetchStaffDetail = (id) => async (dispatch) => {
    try {
        dispatch(startLoading());

        const { data, status } = await apiRequest({
            endUrl: apiUrl.staff.staffInfo,
            params: { staffId: id },
        });

        if (status) {
            dispatch(setStaffDetail({
                data
            }));
            return true;
        }
    } catch (error) {
        console.error('Error fetching Staff list:', error);
    } finally {
        dispatch(stopLoading());
    }
};

// Export the reducer
export default staffSlice.reducer;
